import React from "react";
import Button from "@mui/material/Button";
import LocalCafeOutlinedIcon from "@mui/icons-material/LocalCafeOutlined";
import { useTranslation } from "react-i18next";

const YesButton = (props) => {
  const { t } = useTranslation();
  return (
    <Button
      variant="contained"
      startIcon={<LocalCafeOutlinedIcon style={{ fontSize: "2rem" }} />}
      color="secondary"
      onClick={props.onClick}
      style={{ width: "18rem", fontSize: "2rem", backgroundColor: "#fb8c00" }}
    >
      {t("Yes")}
    </Button>
  );
};

export default YesButton;
